import HyperlinkKpiTechnicalSupport from "@/components/functionals/HyperlinkKpiTechnicalSupport";
import HyperlinkKpiTechnicalSupportTotal from "@/components/functionals/HyperlinkKpiTechnicalSupportTotal";
import DetalleSLAStatus from "@/components/functionals/DetalleSLAStatus";
import DetalleSatisfaccionCalificacion from "@/components/functionals/DetalleSatisfaccionCalificacion";
import { formatDate } from "../utils";
import ImagePersonVue from "@/components/functionals/ImagePerson.vue";

export const Months = [
  {
    prop: "1",
    name: "Enero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "2",
    name: "Febrero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "3",
    name: "Marzo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "4",
    name: "Abril",
    minWidth: 80,
    aling: "center",
    fixed: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "5",
    name: "Mayo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "6",
    name: "Junio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "7",
    name: "Julio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "8",
    name: "Agosto",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "9",
    name: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "10",
    name: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "11",
    name: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "12",
    name: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "total",
    name: "Total",
    minWidth: 80,
    fixed: true,
    formatter: HyperlinkKpiTechnicalSupportTotal
    // formatter: row => FormatPercentSalesKpi(row.total)
  }
];

export const MonthsRabbey3 = [
  {
    prop: "1",
    label: "Enero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 1
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "2",
    label: "Febrero",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 2
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "3",
    label: "Marzo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 3
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "4",
    label: "Abril",
    minWidth: 80,
    aling: "center",
    fixed: true,
    cellAtrrs: {
      mes: 4
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "5",
    label: "Mayo",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 5
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "6",
    label: "Junio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 6
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "7",
    label: "Julio",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 7,
      mes2: "July"
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "8",
    label: "Agosto",
    minWidth: 80,
    fixed: true,
    aling: "center",
    cellAtrrs: {
      mes: 8
    },
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "9",
    label: "Septiembre",
    cellAtrrs: {
      mes: 9
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "10",
    label: "Octubre",
    cellAtrrs: {
      mes: 10
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "11",
    label: "Noviembre",
    cellAtrrs: {
      mes: 11
    },
    minWidth: 90,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "12",
    label: "Diciembre",
    cellAtrrs: {
      mes: 12
    },
    minWidth: 80,
    fixed: true,
    aling: "center",
    formatter: HyperlinkKpiTechnicalSupport
  },
  {
    prop: "total",
    label: "Total",
    minWidth: 80,
    fixed: true,
    formatter: HyperlinkKpiTechnicalSupportTotal
    // formatter: row => FormatPercentSalesKpi(row.total)
  }
];

export const DetailTechnicalSupportKpi = [
  {
    prop: "ServiceRequestID",
    label: "No.",
    sortable: true,
    minWidth: 80,
    fixed: true
  },
  {
    prop: "DescriptionCorta",
    label: "Descripcion",
    sortable: true,
    minWidth: 270,
    fixed: true
  },
  {
    prop: "tipoServicio",
    label: "Tipo Servicio",
    minWidth: 120,
    sortable: true
  },
  {
    prop: "Assessment",
    label: "Calificación",
    minWidth: 110,
    sortable: true,
    formatter: DetalleSatisfaccionCalificacion
  },
  {
    prop: "RatingComment",
    label: "Comentario de cierre",
    minWidth: 270,
    sortable: true
  },
  {
    prop: "Status",
    label: "Estatus",
    minWidth: 90,
    sortable: true,
    formatter: DetalleSLAStatus
  },
  {
    prop: "TiempoEstablecidoSLA",
    label: "Tiempo SLA",
    sortable: true,
    minWidth: 120
  },
  {
    prop: "CreatedBy",
    label: "Creado Por",
    minWidth: 165,
    sortable: true,
    formatter: ImagePersonVue,
    attrs: {
      imgKey: "CreatedByPhoto"
    }
  },
  {
    prop: "CreatedAt",
    label: "Fecha Registro",
    minWidth: 130,
    sortable: true,
    formatter: (row) => formatDate(row.CreatedAt, "DD/MM/yyyy")
  },
  // {
  //   prop: "AssignedAt",
  //   label: "Fecha Asignación",
  //   minWidth: 100,
  //   sortable: true,
  //   formatter: row => formatDate(row.AssignedAt, "DD/MM/yyyy")
  // },
  {
    prop: "fechaCierre",
    label: "Fecha Cierre",
    minWidth: 120,
    sortable: true,
    formatter: (row) => formatDate(row.fechaCierre, "DD/MM/yyyy")
  },
  {
    prop: "tiempoRespuesta",
    label: "Días de Respuesta",
    minWidth: 150,
    sortable: true
  }
];

export const commentColumns = [
  {
    prop: "user",
    label: "Usuario",
    minWidth: 50,
    fixed: true
  },
  {
    prop: "Fecha",
    label: "Fecha",
    minWidth: 50,
    fixed: true,
    sortable: true,
    formatter: (row) => formatDate(row.Fecha, "DD/MM/yyyy")
  },
  {
    prop: "Comment",
    label: "Comentario",
    minWidth: 200
  }
];
